import { Component, OnInit ,ViewChild, OnDestroy} from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import {DatePipe,formatDate} from '@angular/common';
import {FormBuilder, FormGroup, Validators, FormControl} from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { AccountService } from '../_services/account.service';
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator,MatTableDataSource } from '@angular/material'; 
import { AppConfig, ExcelService } from '../_helpers/index';
import {DebtorService} from '../_services/debtor.service';
import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { accountBankCategoryStatus,accountBankType,accountPSPCreation,accountPSPType} from '../_enums/account';
import {DataService} from '../_helpers/dataservice.service'
import { PSPOperation,PaymentProcess,Invoice,PSPDepositBank } from '../_models';
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {PaymentProcessService} from '../_services/paymentprocess.service';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';


@Component({
    selector: 'accountsoperationbank',
    templateUrl: './accountoperationbank.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css']
})

export class AccountsOperationBankComponent implements OnInit, OnDestroy {

  public customer_public_id:string;
  public bank_public_id:string;
  public customer_Account_public_id:string;

  /*Deposit*/
  selectedRowIndex: number;

  creditEnable =false;
   debitEnable =false;

   public withdrawForm:FormGroup;
   public debitTransferForm:FormGroup;

  public depositForm: FormGroup;
  /*Deposit End */
  public transferForm:FormGroup;
  hideCategorize=false;
  excelExportData: any;
  ddlStatus : any[];
  isLoading=false;
  ddlTransType : any[];
  ddlBankCreation : any[];
  ddlAccountType : any[]; 
  isalertVisiable:boolean;

    searchFilterForm: FormGroup;
    searchRangoFilterForm: FormGroup;
   displayedColumns: string[] = ['select','processing','description', 'total.value','total.type','operation','reference','transaction_info.process_type','transaction_info.debtor.name','status'];
   columnsToDisplay: string[] = this.displayedColumns.slice();
    dataSourceAccOperationBankList = new MatTableDataSource();
    
    displayedColumnsNew: string[] = ['processing','description', 'total.value','total.type','operation', 'reference','transaction_info.process_type','transaction_info.debtor.name','status'];
    columnsToDisplayNew: string[] = this.displayedColumnsNew.slice();
    dataSourceAccOperationBankListNew = new MatTableDataSource();

    displayedColumnsInvoice: string[] = ['select','created','name','total.value','status'];
    dataSourceInvoicesList = new MatTableDataSource();
 
    selection = new SelectionModel<any>(true, []);
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @ViewChild(MatSort) sortnew: MatSort;
    @ViewChild(MatPaginator) paginatornew: MatPaginator;

    filterValue;    
    customerPublic_key;
    isRangoVisiable = false;
    auth0Profile:any;
    ddlOperationBank : any[]; 
    cust_account_name:any;
    enableImportBtn :boolean;
    offsetTimeZone:any;
    offsetMinutes:any;
    offsetTimeVal:any;
    
    public pageIndexDynamic:number;

    isRangoStatus = "None";

    /**Categorize */

    public debtorPublicID:any;
    public debtorPromiseResult:any ="";
    public searchRef:any="";
    public selectinvoicelist:Invoice[]=[];
    psp_OperationPublic_key:any;
    psp_OperationPublic_Id:any;
    psp_OperationTotalAmt:any;
    public elementDebtor:any;
    public user_id : string;

    public paymentID = true;
    public depositID = false;
    public transferID = false;
  
    public checkName = false;
    public Error:any;
    public debitError:any;
    public CreatedDate:string;
    public noValue = false;
    enableConfirmBtn :boolean;
    enableDebitConfirmBtn :boolean;

    public checkDebName = false;
    public noDValue = false;

    invoiceTotalAmt: number = 0.0;
    currencysymbol:any;
    currencydebitsymbol:any;

    invoiceDebitTotalAmt: number = 0.0;

    public enableRadioBtn = false;

    public paymentprocessForm: FormGroup; 
    public _paymentprocess:any;

    searchDebtorFilterForm:FormGroup;

    displayeddebitColumnsInvoice: string[] = ['select','created','total.value'];
    dataSourcedebitInvoicesList = new MatTableDataSource();

    public debitdebtorPromiseResult:any ="";
  
      public debitpaymentID = true;
      public debitwithdrawID = false;
      public debittransferID = false;
  
      searchdebitDebtorFilterForm:FormGroup;
      settlementprocessForm:FormGroup;

    /** This is Constructor function which is used to initialize the class variables and objects; 
     */
    constructor
    (
        private router:Router, private formBuilder:FormBuilder, 
        private _fb:FormBuilder,private excelService:ExcelService
        ,private parameterData:ParameterData,private dataService:DataService
        ,private customerService: CustomerService
        ,private invoicesService: InvoicesService      
        ,private datePipe: DatePipe
        ,private accountService:AccountService
        ,private auth:AuthService  
        ,private readonly activatedRoute: ActivatedRoute
        ,private _accountBankCategoryStatus:accountBankCategoryStatus
        ,private _accountBankType:accountBankType
        ,private _acctype:accountPSPType
        ,private _accountpspcreation:accountPSPCreation
        ,private spinnerService: Ng4LoadingSpinnerService
        ,private debtorService:DebtorService
        ,private _fbpayprocess:FormBuilder
        ,private paymentProcessService:PaymentProcessService
        ,private _fcdeposit:FormBuilder
        ,private _fdtransfer:FormBuilder
        ,private _ffwithdraw:FormBuilder
        ,private _fgtransfer:FormBuilder
     )
    {     
        this.spinnerService.show();
       
        this.ddlStatus = _accountBankCategoryStatus._accountBankCategoryStatus;     
        this.ddlBankCreation = _accountpspcreation._accountpspcreation;
        this.ddlTransType = _accountBankType._accountBankType;  
        this.ddlAccountType = _acctype._accountPSPType; 
        this.enableConfirmBtn = false;   
        this.enableDebitConfirmBtn = false;     
                

    }//end 




    /** This function is used to work the text filter above the grid; 
     */
    applyFilter() {
      
        this.filterValue = this.searchFilterForm.controls.searchText.value;
        this.filterValue = this.filterValue.trim(); 
        this.filterValue = this.filterValue.toLowerCase(); 
        this.dataSourceAccOperationBankList.filter = this.filterValue;
      }//end
      applyDebtorFilter() {
    
        this.filterValue = this.searchDebtorFilterForm.controls.searchText.value;
        this.filterValue = this.filterValue.trim(); 
        this.filterValue = this.filterValue.toLowerCase(); 
        this.invoiceTotalAmt=0;
        this.noValue = false;
        if(this.filterValue !== undefined  && this.filterValue != '' )
        {
    
          this.Error = ' ';
        this.debtorService.searchDebtor(this.customer_public_id,"",this.filterValue)
        .subscribe((data) => {
          let resources = data["data"];
          this.debtorPromiseResult =resources;
          if(resources !==undefined && resources !=null && resources !='')
          {         
            this.checkName =true;
            this.debtorPromiseResult =resources[0].name;
            this.debtorPublicID=resources[0].public_id;
            this.getcustDebtorInvoiceListNEW(resources[0]);
          }
          else
          {
            this.checkName =false;
            this.Error='No se encontro cliente';
            let res;
            this.debtorPromiseResult =res;
          }
     
        },
        error => {
          this.Error='No se encontro cliente';
            
      });

    }
    else
    {
      this.Error='No se encontro cliente';
      let res;
            this.debtorPromiseResult =res;
    }

        
      }//end


      applydebitDebtorFilter() {
    
        this.filterValue = this.searchdebitDebtorFilterForm.controls.searchText.value;
        this.filterValue = this.filterValue.trim(); 
        this.filterValue = this.filterValue.toLowerCase(); 
        this.invoiceDebitTotalAmt=0;
        this.noValue = false;
        if(this.filterValue !== undefined  && this.filterValue != '' )
        {
    
          this.Error = ' ';
        this.debtorService.searchDebtor(this.customer_public_id,"",this.filterValue)
        .subscribe((data) => {
          let resources = data["data"];
          this.debitdebtorPromiseResult =resources;
          if(resources !==undefined && resources !=null && resources !='')
          {         
            this.checkDebName =true;
            this.debitdebtorPromiseResult =resources[0].name;
            this.debtorPublicID=resources[0].public_id;
            this.getcustDebitDebtorInvoiceListNEW(resources[0]);
          }
          else
          {
            this.checkDebName =false;
            this.debitError='No se encontro cliente';
            let res;
            this.debitdebtorPromiseResult =res;
          }
     
        },
        error => {
          this.debitError='No se encontro cliente';
            
      });

    }
    else
    {
      this.debitError='No se encontro cliente';
      let res;
            this.debitdebtorPromiseResult =res;
    }

        
 
      }//end
      /** This is ngOnInit function called after initialising the component; 
     */
    ngOnInit() {
      $('.app-side').addClass('is-mini');
      $("#ex2").css("display", "flex");
      $("#resizegrabber").css("display", "none");
      $("#cateresize").removeClass("resizable").addClass("resizablecate")
      $(".card").removeAttr("cardwidth")
      this.creditEnable =true;
        this.debitEnable =false;
        $("#nav-debit").css("display", "none");
        $("#nav-profile-tab-debit").removeClass("active")
        $("#nav-profile-tab").addClass("active")
        $('.nav a').not('.active').addClass('disabled');
     
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined' ) ? null : localStorage;
    if (browserStorage1 == null) {
       browserStorage = localStorage.getItem('companyId');
       if (browserStorage == null || browserStorage == '' || browserStorage == undefined) 
       {
           this.router.navigate(['/home']);
       } 
       else
       {  
           this.customer_public_id=localStorage.getItem('companyId');
           this.user_id = localStorage.getItem('userId');
       }
    }
    else
    {
         this.customer_public_id=localStorage.getItem('subcompanyId');   
         this.user_id = localStorage.getItem('userId');  
    }
    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
      this.offsetTimeZone=(typeof  browserStorage.getItem('timezone') === 'undefined') ? null :  browserStorage.getItem('timezone');

      if(this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone))
      {
        this.offsetTimeZone= -5.00;
        this.offsetMinutes=0;
        this.offsetTimeVal =(this.offsetTimeZone * 3600000);
        
        AppConfig.settings.userSetting.defaultTimeZone= this.offsetTimeVal; 
      }
      else
      {       
        this.offsetTimeZone= browserStorage.getItem('timezone');      
        this.offsetMinutes=30;
        this.offsetTimeVal =(this.offsetTimeZone * 3600000);
        
        AppConfig.settings.userSetting.defaultTimeZone= this.offsetTimeVal;
      }



      this.enableImportBtn = false;
      
      //////////////////////////


      //used to retrieve the customer Account public id
      let params: any = this.activatedRoute.snapshot.params;
      this.customer_Account_public_id=params.id;
      localStorage.setItem('customraccountid',   this.customer_Account_public_id);
        this.searchFilterForm = this.formBuilder.group({
            searchText: ['', Validators.required]           
          });

          this.searchDebtorFilterForm = this.formBuilder.group({
            searchText: ['', Validators.required]           
          });
          this.searchdebitDebtorFilterForm = this.formBuilder.group({
            searchText: ['', Validators.required]           
          });
          this.searchRangoFilterForm = this._fb.group({
            searchFromDate: [''],
            searchToDate : ['']            
          });

          if(this. _accountpspcreation._accountpspcreation.length>8)
          {
            this. _accountpspcreation._accountpspcreation.shift();
          }

          this.paginator._intl.itemsPerPageLabel="Registros por página";
          this.paginator._intl.nextPageLabel="siguiente página";
          this.paginator._intl.lastPageLabel="última página";
          this.paginator._intl.previousPageLabel="anterior página";
          this.paginator._intl.firstPageLabel="primera página";

          
          
          this.InitialSetup();
          this.GetAccountsDetails();
         this.GetCustomerAccountsOperationBankList();
          this.dataSourceAccOperationBankList.paginator = this.paginator;
          this.dataSourceAccOperationBankList.sort = this.sort; 
          
         
          this.GetAccountsDetailsNew();
         
         
         

      }//end

      ngOnDestroy() {
       
      }//end
      
    

      onRemoveSign(value)
      {
        var Signval = value.toString().substr(1);     
        return Signval;
      }
      /** This function is used to get the invoices list from the service; 
     * it accepts the param customerId
     */

    InitialSetup() {

      this.paymentprocessForm = this._fbpayprocess.group({
          is_confirmed: new FormControl(""), 
          reference: new FormControl(""),
          external_id: new FormControl(""),
          public_id: new FormControl(""),
          status: new FormControl(""),
         
          debtor:this._fbpayprocess.group({                        
              public_id:new FormControl("")
          }),

          user: this._fbpayprocess.group({
              public_id: this.user_id
           }),

         
              
          psp_operation:this._fbpayprocess.group({              
              
              public_id:new FormControl(""),
              customer_account:this._fbpayprocess.group({                 
                  public_id:new FormControl("")
              }),
              psp_account:this._fbpayprocess.group({                
                  public_id:new FormControl("")
              }),
              total:this._fbpayprocess.group({
                  currency:new FormControl(""),
                  value:new FormControl("")
              })
          }),
          invoice_list :this._fbpayprocess.array([
              ({
                  id:[""],
                  public_id:[""],
                  late_fee:this._fbpayprocess.group({
                      currency:[""],
                      symbol:[""],
                      value:(0)
                  }),
                  sub_total:this._fbpayprocess.group({
                      currency:[""],
                      symbol:[""],
                      value:(0)
                  }),
                  total:this._fbpayprocess.group({
                      currency:[""],
                      symbol:[""],
                      value:(0)
                  })
              })
          ])
      });   



      this.settlementprocessForm = this._fbpayprocess.group({
        
        reference: new FormControl(""),
        external_id: new FormControl(""),
        public_id: new FormControl(""),
        status: new FormControl(""),       
        settlement:this._fbpayprocess.group({                        
          public_id:new FormControl("")
      }), 
      transfer:this._fbpayprocess.group({                        
        public_id:new FormControl("")
    }), 
    net_amount:this._fbpayprocess.group({
      currency:new FormControl(""),
      value:new FormControl("")
  }),
  tax_amount:this._fbpayprocess.group({
    currency:new FormControl(""),
    value:new FormControl("")
}),
gross_amount:this._fbpayprocess.group({
  currency:new FormControl(""),
  value:new FormControl("")
}),
fees_amount:this._fbpayprocess.group({
currency:new FormControl(""),
value:new FormControl("")
}),
account:this._fbpayprocess.group({
  public_id:new FormControl("")
  })
      
     
       
    }); 

      this.depositForm=this._fcdeposit.group({
       

        metadata:this._fcdeposit.group({
          notes:new FormControl("",Validators.required)
        })


      });

      this.transferForm=this._fdtransfer.group({
        

        metadata:this._fdtransfer.group({
          notes:new FormControl("",Validators.required)
        })


      });


      this.withdrawForm=this._ffwithdraw.group({
        

        metadata:this._ffwithdraw.group({
          notes:new FormControl("",Validators.required)
        })


      });

      this.debitTransferForm=this._fgtransfer.group({
        
        metadata:this._fgtransfer.group({
          notes:new FormControl(" ",Validators.required)
        })


      });
  }
   //end initial setup


   onsubmit({value}: { value:PaymentProcess})
   {
    
       if (this.invoiceTotalAmt > 0)
       {
         value.invoice_list= this.selectinvoicelist;
         value.is_confirmed = true;
         value.reference = this.searchRef;
         value.name= "EFECTIVO # " + this.searchRef;
         value.debtor.public_id= this.debtorPublicID;
         value.psp_operation.public_id=this.psp_OperationPublic_Id;
         value.psp_operation.total.currency=this.currencysymbol;
         value.psp_operation.total.value=this.invoiceTotalAmt;
         value.psp_operation.customer_account.public_id = this.customer_Account_public_id;
     
       this.paymentProcessService.createPayment(value)
       .subscribe((result) => {
         this.noValue=false;
         this.checkName=false;
         this.searchRef=" ";
         this.invoiceTotalAmt=0;
         this.debtorPromiseResult = " " ;
   
        
   
         
         this.searchDebtorFilterForm.reset();
         
        
         setTimeout(()=> {
           this.spinnerService.show();
           this.isLoading=true;   
           this.GetCustomerAccountsOperationBankList();         
           this.dataSourceAccOperationBankList.paginator = this.paginator;
           this.dataSourceAccOperationBankList.sort = this.sort;  
          this.selectinvoicelist.length=0;
          

           },1000);
        
       
        
       }, error => {
           console.log('Failed while trying to update the Payments Process Details.' + error);
       });
   }
   else
   {
      alert("Please select the Invoice Amount");
      this.isalertVisiable = true;
   }
      
   }

   
    GetCustomerAccountsOperationBankList() 
      {
       
    
          this.accountService.getAccountOperationListBank(this.customer_Account_public_id).subscribe(data => {      
          let resources = data["data"];          
          this.ddlOperationBank = resources;
          this.dataSourceAccOperationBankList.data =resources;
          this.excelExportData=resources; 
          this.spinnerService.hide();
      },
          error => {           
              console.log('Failed! while trying to get the invoices list. ' + error);
          });
      }//end
      

    
    /** This function is used to get the account account details from the service; 
     * it accepts the param account public id
     */
    GetAccountsDetails() 
    {
      this.accountService.getAccount(this.customer_Account_public_id).subscribe(data => { 
        this.cust_account_name=data.name;
        this.bank_public_id=data.public_id;
        if(data.configuration.subscription_id == undefined )
        {
          this.enableImportBtn = false;
        }
        else
        {
          this.enableImportBtn = true;
        }
      
        
   
    },
        error => {     
            console.log('Failed! while trying to get the acccount details list. ' + error);
        });
    }//end
    


    /** This function is used to export the invoices list to the excel file; 
     * it reads the data from the variable excelExportData which is assigened when the lits bind in to the grid
     */
    exportAsXLSX() 
    {
    
      this.setExportExcelFileData(this.excelExportData);
       
    }//end


    setExportExcelFileData(excelExportData) 
    {

      var excelHeader = ["FECHA DE CREACION",	"FECHA DE OPERACIÓN",	"DESCRIPCIÓN","NOMBRE",	"MÉTODO",	"TOTAL",	"ESTADO","TIPO","REFERENCIA"]

      var arrFinalData = [];
      var object_temp = {};
      var k=0;
      var columnsKeyNames=[];

        for(k=0;k<excelExportData.length;k++)
     
        {
          var singleRec_temp=excelExportData[k];
          delete singleRec_temp['fee'];
         
          delete singleRec_temp['external_id'];
     


          columnsKeyNames=Object.keys(singleRec_temp);

          var created_temp;
          var processing_date_temp;
          var description_temp;
          var name_temp;
          var method_temp;
          var total_temp;
          var status_temp;
          var type_temp;
          var referebce_temp;
          var client_temp;
       
         

       

          object_temp={};

          for (var i = 0; i < columnsKeyNames.length; i++)
          {
            if(columnsKeyNames[i]=="created")
            {
              created_temp=singleRec_temp[columnsKeyNames[i]];
            }

            if(columnsKeyNames[i]=="processing_date")
            {
              processing_date_temp=singleRec_temp[columnsKeyNames[i]];
            }
            
            if(columnsKeyNames[i]=="description")
            {
              description_temp=singleRec_temp[columnsKeyNames[i]];
            }

            if(columnsKeyNames[i]=="name")
            {
              name_temp=singleRec_temp[columnsKeyNames[i]];
            }

            if(columnsKeyNames[i]=="method")
            {
              method_temp=singleRec_temp[columnsKeyNames[i]];
            }
               

          if(columnsKeyNames[i]=="total")
            {
              total_temp= singleRec_temp[columnsKeyNames[i]].value;
             
            }
          

            var statusEnglish;
            if(columnsKeyNames[i]=="status")
            {
              statusEnglish=singleRec_temp[columnsKeyNames[i]];

              switch (statusEnglish) 
              { 
                  case'NEW': 
                      status_temp='CATEGORIZAR'
                      break; 
                  case'CONFIRMED': 
                      status_temp='CATEGORIZAR'
                      break; 
                  case'CANCELLED': 
                      status_temp='Cancelado'
                      break;
                  case'CATEGORIZED': 
                      status_temp='Categorizado'
                      break;
                  case'PROCESSED': 
                      status_temp='Procesado'
                  break; 
                  case'RECONCILED': 
                      status_temp='Reconciliado'
                      break;
               
                  default: 
                      status_temp=statusEnglish;

              }//end switch

            }

            if(columnsKeyNames[i]=="type")
            {
              type_temp= singleRec_temp[columnsKeyNames[i]];
             
            }

            if(columnsKeyNames[i]=="reference")
            {
              referebce_temp= singleRec_temp[columnsKeyNames[i]];
             
            }

          
           
           

          }//end for

          

          // for (var j = 0; j < excelHeader.length; j++)
          // {
          //   if(excelHeader[j]=="FECHA DE CREACION")
          //   {
          //     object_temp[excelHeader[j]]=created_temp
          //   }

          //   if(excelHeader[j]=="FECHA DE OPERACIÓN")
          //   {
          //     object_temp[excelHeader[j]]=processing_date_temp;
          //   }
            
          //   if(excelHeader[j]=="DESCRIPCIÓN")
          //   {
          //     object_temp[excelHeader[j]]=description_temp;
          //   }

          //   if(excelHeader[j]=="NOMBRE")
          //   {
          //     object_temp[excelHeader[j]]=name_temp;
          //   }

          //   if(excelHeader[j]=="MÉTODO")
          //   {
          //     object_temp[excelHeader[j]]=method_temp;
          //   }


          //   if(excelHeader[j]=="TOTAL")
          //   {
          //     object_temp[excelHeader[j]]=total_temp;
          //   }


          //   if(excelHeader[j]=="ESTADO")
          //   {
          //     object_temp[excelHeader[j]]=status_temp;
          //   }

          //   if(excelHeader[j]=="TIPO")
          //   {
          //     object_temp[excelHeader[j]]=type_temp;
          //   }

          //   if(excelHeader[j]=="REFERENCIA")
          //   {
          //     object_temp[excelHeader[j]]=referebce_temp;
          //   }

          
          // }//end for
          arrFinalData.push([created_temp, processing_date_temp, description_temp, name_temp, method_temp, total_temp, status_temp, type_temp, referebce_temp]);
        }

        this.excelService.generateKashioExcelFile(excelHeader ,arrFinalData, 'BankOperationList');
       
    }//end function

    importAsXLSX()
    {
      
      this.router.navigate([`/accounts/bank/${this.customer_Account_public_id}/import`]);
      
    }//end

    /** This function is used to filter the Account list based on Creation Detail wise; 
     * it accepts the param select status value
     */
    filterAccountTransDetails(accounttype)
    {   
      
      if (accounttype==this.ddlTransType[0].value)
      {       
       
        this.dataSourceAccOperationBankList.filter = '';
      }
   
      else 
      {   
        
        this.dataSourceAccOperationBankList.filter = '';       
        this.dataSourceAccOperationBankList.filterPredicate = (data: PaymentProcess, filter: string) => 
         data.transaction_info!==undefined && data.transaction_info.process_type == accounttype ;   
        this.dataSourceAccOperationBankList.filter = accounttype;

          
      }        
     
    }//end
    

    /** This function is used to filter the Account list based on Creation Detail wise; 
     * it accepts the param select status value
     */
    filterAccountTypeDetails(accounttype)
    {   
     
      if (accounttype==this.ddlAccountType[0].value)
      {       
        this.dataSourceAccOperationBankList.filter = '';
      }
      else 
      {   
        this.dataSourceAccOperationBankList.filter = '';       
        this.dataSourceAccOperationBankList.filterPredicate = (data: PaymentProcess, filter: string) => 
        data.psp_operation.metadata.process_type == accounttype;        
        this.dataSourceAccOperationBankList.filter = accounttype;
      }        
     
    }//end
    
    viewPspDetails(element)
    {
      
      this.router.navigate([`/psp/${element.public_id}/view`]);
    }



    /** This function is used to filter the Account list based on Status Detail wise; 
     * it accepts the param select status value
     */
    
    filterAccountStatusDetails(status)
    {     
     
        if (status==this.ddlStatus[0].value)
        {       
          this.dataSourceAccOperationBankList.filter = '';
        }
        else if (status==this.ddlStatus[1].value)
        {   
          this.dataSourceAccOperationBankList.filter = '';
         
          this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) => 
          data.status.toLowerCase()=='NEW';  
          
          this.dataSourceAccOperationBankList.filter = 'NEW';
        }            
          else if (status==this.ddlStatus[2].value)
          {    
            this.dataSourceAccOperationBankList.filter = '';
           this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>       
           data.status=='CONFIRMED';     
        
          this.dataSourceAccOperationBankList.filter='CONFIRMED';
        }
        else if (status==this.ddlStatus[3].value)
        {    
         this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>       
         data.status=='CANCELLED';     
      
        this.dataSourceAccOperationBankList.filter='CANCELLED';
      }  
      else if (status==this.ddlStatus[4].value)
      {    
       this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>       
       data.status=='CATEGORIZED';     
    
      this.dataSourceAccOperationBankList.filter='CATEGORIZED';
    }  
    else if (status==this.ddlStatus[5].value)
    {    
     this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>       
     data.status=='PROCESSED';     
  
    this.dataSourceAccOperationBankList.filter='PROCESSED';
  }    
  else if (status==this.ddlStatus[6].value)
  {    
   this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) =>       
   data.status=='RECONCILED';     

  this.dataSourceAccOperationBankList.filter='RECONCILED';
}    
    }
    
    //end


     /*
     * This function is used to filter the invoices list based on Creation details based; 
     * it accepts the param select Creation Date values      
     */

    filterAccountCreationDetails(creation)
    {
      
   
      var currentDate = new Date();

      var currentweekFirstDate = new Date();
      var currentweekLastDate = new Date();      

      var lastweekFirstDate = new Date();
      var lastweekLastDate = new Date();

      currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
      currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

      var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

      var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth()-1, 1);
      var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

      lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
      lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);

     

      // All Datas Condition
      if(creation == 0 )
      {
        this.dataSourceAccOperationBankList.filter ='';   
      }

        // Current Month Filter Condition
        if(creation == 1)
        {
          this.dataSourceAccOperationBankList.filter ='';           
          let CurrentmonthFirstDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00','en-US');
          let CurrentmonthEndDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00','en-US');

          this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) => 
          data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;
          
        }

      // Current Week Filter Condition
      if(creation == 2)
      {
        this.dataSourceAccOperationBankList.filter ='';           
        var WeekstartDate1 = new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00','en-US'));
        var WeekendDate1 = new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00','en-US'));
       
        let WeekstartDate = this.convertGMTTime(WeekstartDate1);
        let WeekendDate = this.convertGMTTime(WeekendDate1);

        
        this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) => 
        data.created >= WeekstartDate && data.created <= WeekendDate;
        
      }

      // Today Filter Condition
      if(creation == 3)
      
      {
        
        this.dataSourceAccOperationBankList.filter ='';       
        currentDate.setDate(currentDate.getDate());
        currentDate.setDate(currentDate.getDate());
    
        var todayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00','en-US')); 
        let startDate = this.convertGMTTime(todayStartDate);

        var todayEndndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00','en-US'));
        let endDate =  this.convertGMTTime(todayEndndDate);

        this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) => 
        data.created >= startDate && data.created <= endDate;        
      }

      // Yesterday Filter Condition
      if(creation == 4)
      {
        this.dataSourceAccOperationBankList.filter ='';      
        currentDate.setDate(currentDate.getDate() - 1);

        var yesterdayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00','en-US',)); 
        let startDate = this.convertGMTTime(yesterdayStartDate);
   
        var yesterdayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00','en-US'));
        let endDate =  this.convertGMTTime(yesterdayEndDate);

        this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) => 
        data.created >= startDate && data.created <= endDate;        
      }

     
      // Last Week Filter Condition
      if(creation == 5)
      {
        this.dataSourceAccOperationBankList.filter ='';    
      
         var lastWeekstartDate1 = new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00','en-US',)); 
         let lastWeekstartDate = this.convertGMTTime(lastWeekstartDate1);
       
         var lastWeekendDate1 = new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:00','en-US'));
         let lastWeekendDate = this.convertGMTTime(lastWeekendDate1);
        
    
        this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) => 
        data.created >= lastWeekstartDate && data.created <= lastWeekendDate;

       
      }

      // Last Month Filter Condition
      if(creation == 6 )
      {
        this.dataSourceAccOperationBankList.filter ='';           
        var LastmonthFirstDate1 = new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00','en-US',)); 
        let LastmonthFirstDate = this.convertGMTTime(LastmonthFirstDate1);
      
        var LastmonthEndDate1 = new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:00','en-US'));
        let LastmonthEndDate = this.convertGMTTime(LastmonthEndDate1);

        this.dataSourceAccOperationBankList.filterPredicate = (data: PSPOperation, filter: string) => 
        data.created >= LastmonthFirstDate && data.created <= LastmonthEndDate;
        
      }
      if(creation != 0 )
      {
      this.dataSourceAccOperationBankList.filter ='2018-10-24 01:59:45';
      }
    
    
     // Range Filter Condition
      if (creation == 7)
      {
        this.isRangoStatus="creation";
        this.isRangoVisiable =true;
       
      }
      else
      {
        this.isRangoStatus="None";
        this.isRangoVisiable =false;
      }
    }//end

    filterAllDetails()
    {
     
     
      if (this.searchRangoFilterForm.controls.searchFromDate.value !== null && this.searchRangoFilterForm.controls.searchToDate.value !== null
          && this.searchRangoFilterForm.controls.searchFromDate.value !== '' && this.searchRangoFilterForm.controls.searchToDate.value !== ''
        )
      {
      if ( this.isRangoStatus=="creation")
      {
        this.filterRangoDetails();
      }
    }
    else
    {
      this.isRangoVisiable = false;
    }

    }


       /** This function is used to filter the invoices list based on Rango From and To Date wise; 
     * it accepts the param select status value
     */
    filterRangoDetails()
    {
      

      if(this._accountpspcreation._accountpspcreation.length>8)
      {
        this._accountpspcreation._accountpspcreation.shift();
      }

      if (this.searchRangoFilterForm.controls.searchFromDate.value != '' && this.searchRangoFilterForm.controls.searchToDate.value != '' )
      {
              this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value,"dd/MM/yyyy") +'-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value,"dd/MM/yyyy");
     
              this.ddlBankCreation.unshift({ value: 8, name: this.filterValue });
      
              this.isRangoVisiable=false;
 
        
          this.dataSourceAccOperationBankList.filter ='';           
          let CurrentmonthFirstDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00','en-US');
          let CurrentmonthEndDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00','en-US');
          this.dataSourceAccOperationBankList.filterPredicate = (data: PaymentProcess, filter: string) => 
          data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;
          
          this.dataSourceAccOperationBankList.filter ='2018-10-24 01:59:45';
      }

    }//end

    convertGMTTime(startDate1)
    {
      if (this.offsetTimeZone >0)
      {
       let date:any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss','en-US');
      return startDate;
      }
      else
      {
     var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
     var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes()- this.offsetMinutes));
     let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss','en-US');
     return startDate;
      }
    }

 


    /**Catgorize Start */

    CategorizeWindow(element)
    {
      this.selectedRowIndex = element.id;
    
      $("#ex2").css("display", "flex");
      $("#resizegrabber").css("display", "none");
      $("#cateresize").removeClass("resizable").addClass("resizablecate")
      $(".card").removeAttr("cardwidth")
      

  
      this.psp_OperationPublic_key=element.public_id;
      if(element.type == "CREDIT")
      {
        this.creditEnable =true;
        this.debitEnable =false;
        $("#nav-debit").css("display", "none");
        $("#nav-profile-tab-debit").removeClass("active")
        $("#nav-profile-tab").addClass("active")
        $('.nav a').not('.active').addClass('disabled');
      }
      else if(element.type == "DEBIT")
      {
        this.creditEnable =false;
        this.debitEnable =true;
        $("#nav-home").css("display", "none");
        $("#nav-profile-tab").removeClass("active")
        $("#nav-profile-tab-debit").addClass("active")
        $('.nav a').not('.active').addClass('disabled');
      
      }
      
      this.GetCustomerAccountsOperationBankListNew();



    }

   

    GetCustomerAccountsOperationBankListNew() 
      {
      
       setTimeout(() => { 
        this.accountService.getAccountOperationListBank(this.customer_Account_public_id).subscribe(data => {      
          let resources = data["data"];          
   
          this.excelExportData=resources; 

         this.elementDebtor=resources.filter(t=>t.public_id ==  this.psp_OperationPublic_key);
         
     this.dataSourceAccOperationBankListNew.data  = this.elementDebtor;    
          this.getDebtorDetails(this.elementDebtor[0]);
        
          this.spinnerService.hide();
      },
          error => {           
              console.log('Failed! while trying to get the invoices list. ' + error);
          });
        },500);
       
      }//end

      getDebtorDetails(element)
      {
 
       this.searchRef=element.reference;
       this.currencysymbol = element.total.symbol;
       this.currencydebitsymbol=element.total.symbol;
       this.psp_OperationTotalAmt = element.total.value;
       this.psp_OperationPublic_Id =element.public_id;
      
       this.Error = ' ';
       this.invoiceTotalAmt=0;
       this.invoiceDebitTotalAmt=0;

       this.debtorService.searchDebtor(this.customer_public_id,"",element.reference)
       .subscribe((data) => {
         let resources = data["data"];
       
         if(resources !==undefined && resources !=null && resources !='')
         {         
           this.checkName =true;
           this.checkDebName=true;
           this.debtorPromiseResult =resources[0].name;
           this.debtorPublicID=resources[0].public_id;
           this.searchRef=resources[0].document_id;
           this.getcustDebtorInvoiceListNEW(resources[0]);
           
         }
         else
         {
           this.noValue=false;
           this.checkName =false;
           this.checkDebName=false;
           this.noDValue=false;
           this.searchRef=" ";
           this.Error='No se encontro cliente';
           let res;
           this.debtorPromiseResult=res;
         }
    
       },
       error => {
         this.Error='No se encontro cliente';
           
     });
      }

           /**
     * this function is used to get the debtor invoice list .
     */
    getcustDebtorInvoiceListNEW(element)
    {
     
      if(element!== undefined)
      {
        if(element.public_id !== undefined || element.public_id != null)
        {
          
        this.debtorService.getDebtorInvoiceListWithFilters(element.public_id)
        .subscribe(data =>{
            let resources = data["data"];     
            this.dataSourceInvoicesList.data  =  resources;
            this.dataSourceInvoicesList.data= resources.filter(d=>d.total.symbol == this.currencysymbol);

         
        if(element.name !== undefined || element.name != null)
        {
            this.debtorPromiseResult =element.name;
            this.checkName =true;
            
            if(typeof resources !== 'undefined' && resources.length > 0)
            {
              this.noValue = true;
            }
            else
            {
              this.noValue = false;
            }
          
        }
        else
        {
          this.checkName =false;
          this.noValue = false;
          this.searchRef=" ";
        }
            
       
        });
      }
  else 
  {
     let resources ;
     this.dataSourceInvoicesList.data = resources;
     this.debtorPromiseResult = '';
  }
}
else
{
  this.checkName=false;
  this.noValue = false;
  let resources ;
  this.dataSourceInvoicesList.data = resources;
  this.debtorPromiseResult = '';
}
    }
/**
     * this function is used to get the debtor invoice list .
     */
    getcustDebitDebtorInvoiceListNEW(element)
    {
      
      if(element!== undefined)
      {
        if(element.public_id !== undefined || element.public_id != null)
        {
          
        this.debtorService.getDebtorInvoiceListWithFilters(element.public_id)
        .subscribe(data =>{
            let resources = data["data"];     
            this.dataSourcedebitInvoicesList.data  =  resources;
            this.dataSourcedebitInvoicesList.data= resources.filter(d=>d.total.symbol == this.currencydebitsymbol);
           
         
        if(element.name !== undefined || element.name != null)
        {
            this.debitdebtorPromiseResult =element.name;
            this.checkDebName =true;
            
            if(typeof resources !== 'undefined' && resources.length > 0)
            {
              this.noDValue = true;
            }
            else
            {
              this.noDValue = false;
            }
          
        }
        else
        {
          this.checkDebName =false;
          this.noDValue = false;
          this.searchRef=" ";
        }
            
       
        });
      }
  else 
  {
     let resources ;
     this.dataSourcedebitInvoicesList.data = resources;
     this.debitdebtorPromiseResult = '';
  }
}
else
{
  this.checkDebName=false;
  this.noDValue = false;
  let resources ;
  this.dataSourcedebitInvoicesList.data = resources;
  this.debitdebtorPromiseResult = '';
}
    }

    /**
     * this function is used to get the debtor invoice list .
     */
    getcustDebtorInvoiceList(element)
    {
      
    
      if(element.metadata!== undefined )
      {
        if(element.metadata.debtor.public_id !== undefined || element.metadata.debtor.public_id != null)
        {
          this.debtorPublicID=element.metadata.debtor.public_id;
        this.debtorService.getDebtorInvoiceListWithFilters(element.metadata.debtor.public_id)
        .subscribe(data =>{
            let resources = data["data"];     
            this.dataSourceInvoicesList.data  =  resources;
         
         
        if(element.metadata.debtor.name !== undefined || element.metadata.debtor.name != null)
        {
            this.debtorPromiseResult =element.metadata.debtor.name;
            this.checkName =true;
            this.noValue = true;
        }
        else
        {
          this.checkName =false;
          this.noValue = false;
        }            
         this.dataSourceInvoicesList.filter='';
        });
      }
  else 
  {
     let resources ;
     this.dataSourceInvoicesList.data = resources;
     this.debtorPromiseResult = '';
  }
}
else
{
  this.checkName=false;
  this.noValue = false;
  let resources ;
  this.dataSourceInvoicesList.data = resources;
  this.debtorPromiseResult = '';
}

    }//end

    
    /** This function is used to get the account account details from the service; 
     * it accepts the param account public id
     */
    GetAccountsDetailsNew() 
    {
      this.accountService.getAccount(this.customer_Account_public_id).subscribe(data => { 
        this.cust_account_name=data.name;
    },
        error => {     
            console.log('Failed! while trying to get the acccount details list. ' + error);
        });
    }//end
    

      


    onPaymentClick()
    {
      this.depositID = false;
      this.paymentID = true;
      this.transferID=false;
    }

    onDespositClick()

    {
      this.depositID = true;
      this.paymentID = false;
      this.transferID=false;

    }

    onTransferClick() 
    {
      this.depositID = false;
      this.paymentID = false;
      this.transferID=true;

    }

    onSettlementClick()
    {
      this.debitwithdrawID = false;
      this.debitpaymentID = true;
      this.debittransferID=false;
    }

    onWithdrawClick()

    {
      this.debitwithdrawID = true;
      this.debitpaymentID = false;
      this.debittransferID=false;

    }

    onDebitTransferClick() 
    {
      this.debitwithdrawID = false;
      this.debitpaymentID = false;
      this.debittransferID=true;

    }

/*Deposit */
    onsubmitDeposit({value}: { value:PSPDepositBank})

      {
      
      if(this.psp_OperationPublic_Id !==undefined)
      {
        this.paymentProcessService.createDeposit(this.psp_OperationPublic_Id,value)
        .subscribe((result) => {
          setTimeout(()=> {
            this.spinnerService.show();
            this.isLoading=true;   
            this.GetCustomerAccountsOperationBankList();         
            this.dataSourceAccOperationBankList.paginator = this.paginator;
            this.dataSourceAccOperationBankList.sort = this.sort;  
    
            },500);

        },
       error => {
       
          console.log('Failed while trying to update the Payments Deposit Details.' + error);
      });
    }
      }

      /*Transfer */

      onsubmitTransfer({value}: { value:PSPDepositBank})

      {
     
      if(this.psp_OperationPublic_Id !==undefined)
      {
        this.paymentProcessService.createDeposit(this.psp_OperationPublic_Id,value)
        .subscribe((result) => {
          setTimeout(()=> {
            this.spinnerService.show();
            this.isLoading=true;   
            this.GetCustomerAccountsOperationBankList();         
            this.dataSourceAccOperationBankList.paginator = this.paginator;
            this.dataSourceAccOperationBankList.sort = this.sort;  
    
            },500);

        },
       error => {
          console.log('Failed while trying to update the Payments Transfer Details.' + error);
      });

    }
      }


      /*Withdrawn */
      onsubmitWithdrawForm({value}: { value:PSPDepositBank})
    {
     
      this.paymentProcessService.createDeposit(this.psp_OperationPublic_Id,value)
      .subscribe((result) => {
        setTimeout(()=> {
          this.spinnerService.show();
          this.isLoading=true;   
          this.GetCustomerAccountsOperationBankList();         
          this.dataSourceAccOperationBankList.paginator = this.paginator;
          this.dataSourceAccOperationBankList.sort = this.sort;  
  
          },500);

      },
     error => {
        console.log('Failed while trying to update the Payments Deposit Details.' + error);
    });


    }


    /*With Transfer*/

    
   onsubmitWithTransfer({value}: { value:PSPDepositBank})
    {
   
      this.paymentProcessService.createDeposit(this.psp_OperationPublic_Id,value)
      .subscribe((result) => {
        setTimeout(()=> {
          this.spinnerService.show();
          this.isLoading=true;   
          this.GetCustomerAccountsOperationBankList();         
          this.dataSourceAccOperationBankList.paginator = this.paginator;
          this.dataSourceAccOperationBankList.sort = this.sort;  
  
          },500);

      },
     error => {
        console.log('Failed while trying to update the Payments Transfer Details.' + error);
    });


    }

    /*Settlement*/
    ondebitsubmit(value)
    {
      
    }
    /** Selects individual row if they are not selected; otherwise clear selection. */

    

 
  /*Credit */
selectRow(row) {  

  if (this.selection.isSelected(row))
  {
      this.selection.toggle(row);
      this.invoiceTotalAmt = this.invoiceTotalAmt - row.total.value;       
  }
  else
  {       
      this.selection.toggle(row);
      this.invoiceTotalAmt = this.invoiceTotalAmt + row.total.value;
      this.selectinvoicelist.push(row);     
  }

  if (this.psp_OperationTotalAmt == this.invoiceTotalAmt)
  {
     this.enableConfirmBtn = true;
  }
  else
  {
    this.enableConfirmBtn = false;
  }
}

/*Debit */

selectDebitRow(row) {  

  if (this.selection.isSelected(row))
  {
      this.selection.toggle(row);
      this.invoiceDebitTotalAmt = this.invoiceDebitTotalAmt - row.total.value;       
  }
  else
  {       
      this.selection.toggle(row);
      this.invoiceDebitTotalAmt = this.invoiceDebitTotalAmt + row.total.value;
      this.selectinvoicelist.push(row);     
  }

  if (this.psp_OperationTotalAmt == this.invoiceDebitTotalAmt)
  {
     this.enableDebitConfirmBtn = true;
  }
  else
  {
  
    this.enableDebitConfirmBtn = false;
  }
}

viewInvoiceDetails(element) { 

  const application = localStorage.getItem('application');
  this.dataService.changeinvoicepublicKey(element.public_id);
  if (AccountTypeOptions[application] != undefined) {
    this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${element.public_id}/view`]);
  }
}


btngoBack()
{
  this.router.navigate([`/accounts/bank/${this.customer_Account_public_id}/operations`]);
}
showFullwindow()
{
  $("#ex2").css("display", "none");
  $("#resizegrabber").css("display", "none"); 
  $("#cateresize").removeClass("resizablecate").addClass("resizable")
  
 

}

}//end class


